import { Component, OnInit } from '@angular/core';

import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-preview-alert',
    templateUrl: './preview-alert.component.html',
    styleUrls: ['./preview-alert.component.css']
})
export class PreviewAlertComponent implements OnInit {
    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig
    ) {}

    ngOnInit(): void {
        console.log(this.config.data);
    }

    saveAlertAcknowledgement(): void {
        sessionStorage.setItem('alertAcknowledged', 'yes');
        this.ref.close();
    }
}
